import { useTranslation } from 'react-i18next';

import { classNames, noop } from '../../utils';
import { FileInput } from 'flowbite-react';

export const FileInputElement = ({
    name,
    label,
    accept = 'image/png, image/jpeg',
    forceWidth,
    multiple,
    onChange = noop,
    onBlurChange
}: {
    name: string;
    label?: string;
    accept?: string;
    multiple?: boolean;
    forceWidth?: number;
    onBlurChange?: any;
    onChange?: (item: { [key: string]: string | number }) => void;
}) => {
    const { t } = useTranslation();

    const handleChange = (e: { target: { files: any } }) => {
        onChange({ [name]: e.target.files });
    };

    return (
        <div
            className={`'w-full  mb-[24px]'}`}
            style={{ width: forceWidth ? `${forceWidth}ch` : '100%' }}
        >
            {label && (
                <label
                    htmlFor={`${name}`}
                    className="block text-sm font-normal leading-6 text-black"
                >
                    {t(label)}
                </label>
            )}
            <div
                className={classNames(
                    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-transparent outline-0',
                    'mt-1 relative shadow-sm'
                )}
            >
                <FileInput
                    style={{ borderRadius: 0 }}
                    onChange={handleChange}
                    accept={accept}
                    multiple={multiple}
                    onBlur={onBlurChange}
                    
                />
            </div>
        </div>
    );
};
